module.exports = __webpack_public_path__ + "static/media/muted_mic_active.dfeb075e.svg";